<div class="container contact-form" id="contacto" #rootElement>
    <div class="contact-image">
        <img src="assets/img/logo.png" />
    </div>
    <form method="post" name="form" (ngSubmit)="f.form.valid && enviarMensaje()" #f="ngForm">
        <h3 class="text-center mt-3">Preguntas, dudas, comentarios, sugerencias</h3>
        <div class="row mt-3">
            <div class="col-md-6">
                <div class="form-group">
                    <input type="text" name="txtName" class="form-control" placeholder="Tu nombre *"
                        [(ngModel)]="contacto.nombre" [ngClass]="{'is-invalid':  f.submitted && nombre.invalid}"
                        #nombre="ngModel" required />
                    <div *ngIf="f.submitted && nombre.invalid" class="invalid-feedback">
                        <div *ngIf="nombre.errors.required">El nombre es requerido</div>
                    </div>
                </div>
                <div class="form-group">
                    <input type="text" name="txtEmail" class="form-control" placeholder="E-mail *" email
                        [(ngModel)]="contacto.email" [ngClass]="{'is-invalid':  f.submitted && email.invalid}"
                        #email="ngModel" required />
                    <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                        <div *ngIf="email.errors.required">El e-mail es requerido</div>
                        <div *ngIf="email.errors.email">Tiene que ingresar un correo válido</div>
                    </div>
                </div>
                <div class="form-group">
                    <input type="text" name="txtPhone" class="form-control" placeholder="Teléfono *"
                        [(ngModel)]="contacto.telefono" [ngClass]="{'is-invalid':  f.submitted && telefono.invalid}"
                        #telefono="ngModel" required />
                    <div *ngIf="f.submitted && telefono.invalid" class="invalid-feedback">
                        <div *ngIf="telefono.errors.required">El teléfono es requerido</div>
                    </div>
                </div>
                <div class="form-group">
                    <input type="submit" name="btnSubmit" class="btnContact" value="Enviar Mensaje" />
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6">
                            <img style="max-height: 39px;" [src]="captchaUrl" />
                        </div>
                        <div class="col-md-6">
                            <input type="text" name="txtCaptcha" class="form-control" placeholder="Captcha *"
                                [(ngModel)]="contacto.captcha"
                                [ngClass]="{'is-invalid':  f.submitted && captcha.invalid}" #captcha="ngModel"
                                required />
                        </div>
                    </div>

                </div>
                <div class="form-group">
                    <textarea name="txtMsg" class="form-control" placeholder="Tu mensaje *"
                        [(ngModel)]="contacto.mensaje" style="width: 100%; height: 100px;"
                        [ngClass]="{'is-invalid':  f.submitted && mensaje.invalid}" #mensaje="ngModel"
                        required></textarea>
                    <div *ngIf="f.submitted && mensaje.invalid" class="invalid-feedback">
                        <div *ngIf="mensaje.errors.required">El mensaje es requerido</div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>